// extracted by mini-css-extract-plugin
module.exports = {"content":"featuredSport_content__wtsv_","boxTemplate":"featuredSport_boxTemplate__FLdgb"};